(function () {
  let loaded = false;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    if (!window.Shopify || !Shopify.customerPrivacy) return;

    const consent = Shopify.customerPrivacy.getConsent();

    if (consent.analytics || consent.marketing) {
      loadTracking();
    }

    Shopify.customerPrivacy.onConsentUpdate(function (updated) {
      if ((updated.analytics || updated.marketing) && !loaded) {
        loadTracking();
      }
    });
  });

  function loadTracking() {
    if (loaded) return;
    loaded = true;

    console.log('Consent granted → loading trackers');

    loadFacebookPixel();
    loadFacebookSDK();
    loadYotpo();
    loadBeeketing();
    loadIStock();
    loadClicky();
  }

  /* ========= TRACKERS ========= */

  function loadFacebookPixel() {
    !function(f,b,e,v,n,t,s){
      if(f.fbq)return;
      n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];
      t=b.createElement(e);t.async=!0;
      t.src=v;
      s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s);
    }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');

    fbq('init', '279413225743628');
    fbq('track', 'PageView');
  }

  function loadFacebookSDK() {
    const js = document.createElement('script');
    js.src = '//connect.facebook.net/en_US/all.js#xfbml=1&appId=127142210767229';
    js.async = true;
    document.body.appendChild(js);
  }

  function loadYotpo() {
    const s = document.createElement('script');
    s.src = '//staticw2.yotpo.com/JBnhDFoISLBwe2DodocRRQ1m4DYu5017RU7Cnto0/widget.js';
    s.async = true;
    document.head.appendChild(s);
  }

  function loadBeeketing() {
    const s = document.createElement('script');
    s.src = '/apps/bk-tracking.js'; // Beeketing injects internally
    s.async = true;
    document.head.appendChild(s);
  }

  function loadIStock() {
    const s = document.createElement('script');
    s.src = 'https://istock.shopapps.in/front/iStock-notify-coll-preorder.php';
    s.async = true;
    document.head.appendChild(s);
  }

  function loadClicky() {
    const s = document.createElement('script');
    s.src = '//static.getclicky.com/js';
    s.async = true;
    s.onload = function () {
      try { clicky.init(100989533); } catch(e){}
    };
    document.head.appendChild(s);
  }

})();
